export const viewTypes = Object.freeze({
  LIST: 'LIST',
  CARD: 'CARD',
});

export const tabs = Object.freeze({
  COMMUNITY: 'community',
  CREATE: 'create',
});
